import { z } from "zod"

const MAX_FILE_SIZE = 10 * 1024 * 1024 // 10MB
const ACCEPTED_FILE_TYPES = ["image/jpeg", "image/jpg", "image/png", "image/webp", "application/pdf", "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"]

export const complaintSchema = z.object({
  name: z.string().min(2, "Name must be at least 2 characters"),
  phone: z.string().min(10, "Please enter a valid phone number"),
  email: z.string().email("Please enter a valid email address"),
  serviceType: z.string().min(1, "Please select a service type"),
  bookingId: z.string().optional(),
  issue: z.string().min(20, "Please provide at least 20 characters describing your issue").max(500, "Issue description must be less than 500 characters"),
  supportingDocument: z
    .instanceof(File)
    .refine((file) => file.size <= MAX_FILE_SIZE, "File size must be less than 10MB")
    .refine(
      (file) => ACCEPTED_FILE_TYPES.includes(file.type),
      "Only .jpg, .jpeg, .png, .webp, .pdf, .doc and .docx formats are supported"
    )
    .optional()
    .or(z.literal(undefined)),
})

export type ComplaintFormData = z.infer<typeof complaintSchema>
